import { render, staticRenderFns } from "./MemberRegistrationView.vue?vue&type=template&id=adbb5120&scoped=true"
import script from "./MemberRegistrationView.vue?vue&type=script&lang=js"
export * from "./MemberRegistrationView.vue?vue&type=script&lang=js"
import style0 from "./MemberRegistrationView.vue?vue&type=style&index=0&id=adbb5120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbb5120",
  null
  
)

export default component.exports